import { render } from "./NewTask.vue?vue&type=template&id=b56dba1c"
import script from "./NewTask.vue?vue&type=script&lang=js"
export * from "./NewTask.vue?vue&type=script&lang=js"

import exportComponent from "/home/luvenan/projects/get-it-done/get-it-done/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__